/* eslint-disable */
import {
  history,
  initialfinal,
  stageControl,
  toothMovement,
  treatView,
} from "@/gluelayer"
import { Box, Container } from "@mui/material"
import { FC, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"
import { RootState } from "../../../core/app/store"

import nextSvg from "../../assets/bottomToolBar/stage/next.svg"
import nextDisSvg from "../../assets/bottomToolBar/stage/nextDis.svg"
import playSvg from "../../assets/bottomToolBar/stage/play.svg"
import previousSvg from "../../assets/bottomToolBar/stage/previous.svg"
import previousDisSvg from "../../assets/bottomToolBar/stage/previousDis.svg"
import stopSvg from "../../assets/bottomToolBar/stage/stop.svg"
import stopDisSvg from "../../assets/bottomToolBar/stage/stopDis.svg"

import ToolButton from "../ToolBar/toolButton"

import { toggleProps } from "./type"

import { setStageCompareLoadData } from "@/UDTreat/udTreatSlice"
import StageBarForCompare from "../StageBar/stageBarForCompare"
import StageTxTab from "../StageBar/stageTxTab"
import StatusButton from "../StageBar/statusButton"
import "./toggle.scss"

// timer
let timer: string | number | NodeJS.Timeout | undefined
interface BtnObj {
  isBool: boolean
  type: string
}
const { cancelPickTooth } = toothMovement
const { setInitialFinalEnabled } = initialfinal
const bottomNoRefinement = 200
const bottomRefinement = 222
const allNoRefinement = 248
const allRefinement = 270

const ToggleForCompare: FC<toggleProps> = ({
  preparation,
  setReportShow,
  setopenMovement,
  setInitalShow,
  initalShow,
  openMovement,
  isReady,
  setStageObj,
  planList,
  setCurrentPlan,
  currentPlan,
  renamePlanFunction,
  deletePlanFunction,
  attachmentObj,
  setIsStageFold,
  refinementKey,
  setRefinementKey,
  isHasUpAndlow,
  isEdit,
  arLimitShow,
  setStagebarHeight,
  maxRefine,
  setMaxRefine,
  attachStage,
  hasBite,
  isRANL,
  stageBarWidth,
  setStageBarWidth,
  getTxPlans,
  viewIndex,
  onOff,
  stageMaxWidth,
  showTxTab,
}) => {
  const dispatch = useAppDispatch()

  const { switchViewEdit, stageCompareLoadData, isCreateNewRefinement } =
    useAppSelector((state: RootState) => state.udTreatService)

  const { t } = useTranslation("common")

  // 是否折叠,默认折叠状态(Control whether to fold or not)
  const [isFold, setIsFold] = useState<boolean>(true)
  // control btn status
  const [btnObj, setBtnObj] = useState<BtnObj>({
    isBool: true,
    type: "stop",
  })
  const stageBarContainerBottomWrapRef = useRef(null)
  // refinement bool
  const [isRefinement, setIsRefinement] = useState<boolean>(false)

  const [currentPlanForCompare, setCurrentPlanForCompare] = useState({
    txName: "Plan 1",
    index: 1,
  })
  const StageBarForCompareRef = useRef(null)

  const handleSetCurrentPlanForCompare = (plan: {
    txName: string
    index: number
  }) => {
    if (viewIndex === 0) {
      return
    }

    console.info(
      "toggleForCompare handleSetCurrentPlanForCompare plan:",
      plan.txName,
      plan.index,
    )
    console.info("toggleForCompare view index:", viewIndex)
    if (!plan.index) {
      return
    }
    //change the plan
    const switchTxPlanForCompareFlag = treatView.SwitchTxPlan(
      viewIndex,
      plan.index - 1,
    )
    console.info("switchTxPlanForCompareFlag:", switchTxPlanForCompareFlag)
    if (switchTxPlanForCompareFlag) {
      setCurrentPlanForCompare(plan)
      dispatch(setStageCompareLoadData(!stageCompareLoadData))
    }
  }

  // click btns
  const clickToPlay = (type: string) => {
    if (type === "play") {
      setBtnObj({
        type: btnObj.type !== "play" ? "play" : "stop",
        isBool: !btnObj.isBool,
      })
    } else {
      setBtnObj({
        type,
        isBool: !btnObj.isBool,
      })
    }
  }

  useEffect(() => {
    if (!initalShow) {
      setInitialFinalEnabled(false)
    }
  }, [initalShow])
  // refinement key is all will close report and movement
  useEffect(() => {
    if (maxRefine && !refinementKey.includes(maxRefine.toString())) {
      setReportShow(false)
      setopenMovement(false)
    }
  }, [refinementKey])

  const handleKeyDown = (e) => {
    if (!preparation) {
      return
    }
    const elementFocused = document.activeElement

    if (e.keyCode === 32) {
      if (!isReady || arLimitShow) {
        return
      }
      if (
        elementFocused &&
        ((elementFocused.tagName.toLowerCase() === "input" &&
          elementFocused.getAttribute("type") === "text") ||
          elementFocused.tagName.toLowerCase() === "textarea")
      ) {
        return
      }
      e.preventDefault()
      clickToPlay("play")
    }
    //undo
    if (e.ctrlKey && e.keyCode === 90) {
      if (
        !isEdit
          ? true
          : !isReady ||
            initalShow ||
            arLimitShow ||
            isRANL ||
            (maxRefine && !refinementKey.includes(maxRefine.toString()))
      ) {
        return
      }
      history.undo()
    }
    //redo
    if (e.ctrlKey && e.keyCode === 89) {
      if (
        !isEdit
          ? true
          : !isReady ||
            initalShow ||
            arLimitShow ||
            isRANL ||
            (maxRefine && !refinementKey.includes(maxRefine.toString()))
      ) {
        return
      }
      history.redo()
    }
  }
  // keydown
  useEffect(() => {
    if (viewIndex === 0) {
      return
    }

    console.info(
      "currentPlanForCompare name index",
      currentPlanForCompare.txName,
      currentPlanForCompare.index,
    )
    // if (!currentPlanForCompare.index) {
    //   return
    // }
    // //change the plan
    // const switchTxPlanForCompareFlag = treatView.SwitchTxPlan(viewIndex, currentPlanForCompare.index - 1)
    // console.info("switchTxPlanForCompareFlag:", switchTxPlanForCompareFlag)
    // if(switchTxPlanForCompareFlag) {
    //   dispatch(setStageCompareLoadData(!stageCompareLoadData))
    // }
  }, [currentPlanForCompare])

  const ICClickedCb = (methods) => {
    StageBarForCompareRef.current = methods
  }

  const ICClicked = () => {
    const { upper, lower } = stageControl.switchICForCompare(viewIndex)
    StageBarForCompareRef.current.updateStage(upper, lower)
  }

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown)
    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [
    btnObj,
    preparation,
    isReady,
    arLimitShow,
    isEdit,
    initalShow,
    isRANL,
    maxRefine,
    refinementKey,
  ])

  return (
    <Box
      id="stageBarContainer"
      sx={{
        width: stageBarWidth,
        height: "156px",
        border: "none",
        background: "#FFFFFF00", //#82AEBB
        pointerEvents: "auto",
      }}
    >
      <Container
        className={"stageBarContainerTopWrap"}
        style={{
          borderBottom: isFold ? "unset" : "1px solid #455A64",
          width: "100%",
          height: "30px",
          maxWidth: "none",
          display: "flex",
          margin: "0px",
          padding: "0px",
        }}
      >
        <div
          id="left"
          className={"topLeft"}
          style={{
            height: "30px",
            width: "calc(50% - 72px)",
            background: "transparent",
          }}
        >
          {showTxTab ? (
            <StageTxTab
              planList={planList}
              currentPlan={currentPlanForCompare}
              setCurrentPlan={handleSetCurrentPlanForCompare}
              addTreatmetPlan={() => {}}
              deleteTreatmentPlan={() => {}}
              viewEdit={switchViewEdit}
              hideSave={true}
              hideRemove={true}
              hideAdd={true}
            ></StageTxTab>
          ) : (
            <></>
          )}
        </div>
        <div id="center" className={"topCenter"} style={{ width: "144px" }}>
          <ToolButton
            disabled={!isReady || arLimitShow}
            data-testid="Backwards"
            bg={previousSvg}
            disabledBg={previousDisSvg}
            title={"Initial stage"}
            val={"Initial stage"}
            placement={"top"}
            isFocused={true}
            callBack={() => {
              clickToPlay("icStart")
            }}
            sxProps={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              marginTop: "0px",
            }}
          />
          <ToolButton
            disabled={!isReady || arLimitShow}
            data-testid="Play"
            bg={btnObj.type !== "play" ? stopSvg : playSvg}
            disabledBg={stopDisSvg}
            title={btnObj.type !== "play" ? "Play" : "Pause"}
            val={"play"}
            placement={"top"}
            isFocused={true}
            sxProps={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              margin: "0px 16px 0 16px",
            }}
            callBack={() => {
              clickToPlay("play")
            }}
          />
          <ToolButton
            disabled={!isReady || arLimitShow}
            data-testid="Forward"
            bg={nextSvg}
            disabledBg={nextDisSvg}
            title={"Final stage"}
            val={"Final stage"}
            placement={"top"}
            isFocused={true}
            sxProps={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              marginTop: "0px",
            }}
            callBack={() => {
              clickToPlay("icEnd")
            }}
          />
        </div>
        <Box
          className={"topRight"}
          sx={{
            width: "calc(50% - 72px)",
            height: "100%",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          <StatusButton
            text={"I/C"}
            fontSize={13}
            radius={4}
            width={55}
            height={22}
            backgroundColor={"#FFFFFFCC"}
            clickedBackgroundColor={"#02AFEC"}
            color={"#464646"}
            clickedColor={"#FFFFFF"}
            onClickHandle={() => {
              ICClicked()
            }}
            clicked={false}
            setClicked={() => {}}
            visibility={""}
          ></StatusButton>
        </Box>
      </Container>
      <div
        className={"stageBarContainerBottomWrap"}
        style={{
          width: "100%",
          height: "150px",
          display: "flex",
          border: "none",
          justifyContent:
            stageBarWidth > stageBarContainerBottomWrapRef.current?.offsetWidth
              ? "left"
              : "center",
          padding: "0px",
          position: "relative",
        }}
        ref={stageBarContainerBottomWrapRef}
      >
        <StageBarForCompare
          preparation={preparation}
          btnObj={btnObj}
          setBtnObj={setBtnObj}
          isFold={isFold}
          setStageObj={setStageObj}
          setIsRefinement={setIsRefinement}
          isRefinement={isRefinement}
          attachmentObj={attachmentObj}
          setRefinementKey={setRefinementKey}
          refinementKey={refinementKey}
          setStagebarHeight={setStagebarHeight}
          setStageBarWidth={setStageBarWidth}
          maxRefine={maxRefine}
          setMaxRefine={setMaxRefine}
          attachStage={attachStage}
          stageBarWidth={stageBarWidth}
          getTxPlans={getTxPlans}
          viewIndex={viewIndex}
          onOff={onOff}
          stageMaxWidth={stageMaxWidth}
          showTxTab={showTxTab}
          ICClickedCb={ICClickedCb}
        />
      </div>
    </Box>
  )
}
export default ToggleForCompare
